import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchDeleteSchedule, fetchMigrateData, fetchScheduleList } from "../services/migrationServices.js";
import { fetchMigrateSchedule } from "../services/migrationServices.js";

export const useScheduleList = (taskType) =>{
  return useQuery({
      queryKey: ["schedule-list"],
      enabled: !!taskType,
      queryFn: () => fetchScheduleList(taskType),
  });
}

export const useDeleteSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: fetchDeleteSchedule,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['schedule-list'] });
    }
  });
};

export const useMigrationData = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: (payload) => {
        return fetchMigrateData(payload);
      },
      // onSuccess: () => {
      //   // refresh extracttion list
      //   queryClient.invalidateQueries({ queryKey: ['extraction'] });
      // }
    });
  };


  export const useMigrationSchedule = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: (payload) => {
        return fetchMigrateSchedule(payload);
      },
      onSuccess: () => {
        // refresh extracttion list
        queryClient.invalidateQueries({ queryKey: ['schedule-list'] });
      }
    });
  };

